// web/src/screens/permission_denied.ts — UI-D-15.
//
// Recovery screen shown when mic permission is denied or hardware is absent.
// Shows iOS + Android settings paths and a "Pamēģināt vēlreiz" CTA that
// calls acquireMic() again. If retry succeeds → /intro/<gameShortCode>.
// If retry fails → stays on this screen so the user can try again.

import { acquireMic } from "../components/mic.js";
import { navigate } from "../main.js";

export function mount(root: HTMLElement, _props?: unknown): () => void {
  const sess = JSON.parse(sessionStorage.getItem("currentSession") ?? "{}") as {
    gameShortCode?: string;
  };
  const gameShortCode: string = sess.gameShortCode ?? "vocab";

  root.innerHTML = `
    <section
      class="screen-denied"
      style="min-height: 100dvh; padding: var(--space-lg); background: var(--surface); display: flex; flex-direction: column; align-items: center; justify-content: center; gap: var(--space-xl);"
    >
      <svg width="96" height="96" viewBox="0 0 24 24" stroke="var(--danger)" fill="none" stroke-width="2" aria-hidden="true">
        <path d="M12 1a3 3 0 00-3 3v8a3 3 0 006 0V4a3 3 0 00-3-3z"/>
        <path d="M19 10v2a7 7 0 01-14 0v-2"/>
        <line x1="12" y1="19" x2="12" y2="23"/>
        <line x1="3" y1="3" x2="21" y2="21"/>
      </svg>
      <h1 style="font-size: var(--type-heading); text-align: center; max-width: 520px; margin: 0;">
        Mēs nevaram dzirdēt bērnu — mikrofons ir bloķēts.
      </h1>
      <ul style="font-size: var(--type-body); text-align: left; max-width: 520px; margin: 0; padding: 0; list-style: none; display: flex; flex-direction: column; gap: var(--space-md);">
        <li><strong>iPhone/iPad:</strong> Iestatījumi → Safari → Mikrofons → Atļaut</li>
        <li><strong>Android:</strong> Iestatījumi → Lietotnes → Chrome → Atļaujas → Mikrofons → Atļaut</li>
      </ul>
      <button
        class="retry-cta"
        style="background: var(--theme-color); color: var(--text-on-color); border: 0; border-radius: 12px; padding: var(--space-md) var(--space-2xl); font-size: var(--type-heading); font-weight: 600; min-height: 64px; cursor: pointer;"
      >Pamēģināt vēlreiz</button>
    </section>
  `;

  const cta = root.querySelector(".retry-cta") as HTMLButtonElement;

  async function onRetry() {
    cta.disabled = true;
    try {
      await acquireMic();
      navigate(`/intro/${encodeURIComponent(gameShortCode)}`);
    } catch {
      cta.disabled = false;
      // Stay on this screen; user must change settings and try again
    }
  }

  cta.addEventListener("click", onRetry);
  return () => cta.removeEventListener("click", onRetry);
}
